import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, of, map, shareReplay } from 'rxjs';
import { IconName } from '../models/icon-name.type';

@Injectable({ providedIn: 'root' })
export class IconRegistryService {

  private cache = new Map<IconName, Observable<SafeHtml>>();

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  getIcon(name: IconName): Observable<SafeHtml> {

    if (!this.cache.has(name)) {

      const icon$ = this.http
        .get(`assets/icons/${name}.svg`, { responseType: 'text' })
        .pipe(
          map(svg =>
            this.sanitizer.bypassSecurityTrustHtml(svg)
          ),
          shareReplay(1)
        );

      this.cache.set(name, icon$);
    }

    return this.cache.get(name)!;
  }
}
